/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
var readyCall = function (fn) {
    if (window['AlipayJSBridge']) {
        fn();
    }
    else {
        var _once_1 = function () {
            fn();
            document.removeEventListener('AlipayJSBridgeReady', _once_1, false);
        };
        document.addEventListener('AlipayJSBridgeReady', _once_1, false);
    }
};
var call = function (api, options, success, failure) {
    if (typeof options === 'function') {
        failure = success;
        success = options;
        options = {};
    }
    readyCall(function () {
        AlipayJSBridge.call(api, options, success, failure);
    });
};

export { call as c };
